export const environment = {
  production: true,
  apiUrl: 'https://api-dev-feature.lexi.market/',
  stripeKey: 'pk_test_4EnbIQHxwB9LdZn4Bnjy5ibh00HYKZmhXE'
};
